<template>
    <div class="development-report">
        <v-row align="baseline" class="mb-2">
            <v-col>
                <v-radio-group style="margin-top: 0" row v-model="$store.state.reports.granularity">
                    <v-radio label="Ugedage" value="day" />
                    <v-radio label="Dage" value="date" />
                    <v-radio label="Uger" value="week" />
                    <v-radio label="Måneder" value="month" />
                </v-radio-group>
            </v-col>
            <v-col class="graph-type-column">
                <v-radio-group style="margin-top: 0" row v-model="$store.state.reports.graphType">
                    <v-radio label="Faktisk" value="actual" />
                    <v-radio label="Akkumuleret" value="accumulated" />
                </v-radio-group>
            </v-col>
        </v-row>
        <div v-if="loading" style="height: 60vh" class="d-flex align-center justify-center">
            <v-icon size="50px" class="fa-spin">fa-spinner</v-icon>
        </div>
        <div v-else>
            <vue-apex-charts height="400px" :series="totalSeries" :options="totalOptions" />
            <vue-apex-charts height="400px" :series="avgLeadSeries" :options="avgLeadOptions" />
            <vue-apex-charts height="400px" :series="countSeries" :options="countOptions" />
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	components: {
		VueApexCharts
	},
    data () {
        return {
            salesStats: null,
            avgLeadOptions: null,
            totalOptions: null,
            countOptions: null,
            loading: true,
            totalSeries: [],
            avgLeadSeries: [],
            countSeries: []
        }
    },
    computed: {
        range () {
            return this.$store.state.reports.range
        },
        chartOptions () {
            return this.$store.state.reports.chartOptions
        },
        granularity () {
            return this.$store.state.reports.granularity
        },
        graphType () {
            return this.$store.state.reports.graphType
        },
        report () {
            return this.$store.getters['reports/currentReport']
        },
        groupIndex () {
            return this.$store.state.reports.groupIndex
        }
    },
    methods: {
        async getData () {
            this.loading = true
            let response = await this.$http().post('/reports/development', {
                from: this.range[0],
                to: this.range[1],
                granularity: this.granularity,
                graphType: this.graphType,
                campaigns: this.$store.getters['reports/campaigns']
            })
            this.$store.commit('reports/setChartOptions', {
                formatter: this.$options.filters.separator,
                categories: response.data.labels
            })
            this.avgLeadSeries = [response.data.series.avgLeadSeries]
            this.totalSeries = [response.data.series.totalSeries]
            this.countSeries = [response.data.series.countSeries]
            this.setAvgLeadOptions(), this.setTotalOptions(), this.setCountOptions()
            this.loading = false
        },
		setAvgLeadOptions() {
			this.avgLeadOptions = {
				...this.chartOptions,
				colors: ["#00ff00"],
				title: {
					text: "Salg pr. emne"
				}
			};
		},
		setTotalOptions() {
			this.totalOptions = {
				...this.chartOptions,
				colors: ["#ff0000"],
				title: {
					text: "Solgt præmie"
				}
			};
		},
		setCountOptions() {
			this.countOptions = {
				...this.chartOptions,
				colors: ["#00ffff", "#0000ff"],
				title: {
					text: "Afsluttede"
				}
			};
		}
    },
    watch: {
		range: {
			async handler() {
                this.loading = true
                await this.getData()
                this.loading = false
			},
			deep: true
        },
        granularity: function () {
            this.getData()
        },
        report: function () {
            this.getData()
        },
        graphType: function () {
            this.getData()
        },
        groupIndex: function () {
            this.getData()
        }
    },
    async created () {
        this.$store.state.reports.period = 'Dette år'
        this.$store.commit('reports/setRange', 'Dette år')
        await this.getData()
        this.loading = false
    }
}
</script>

<style lang="scss">
.development-report {
    .graph-type-column {
        .v-input--radio-group__input {
            justify-content: flex-end;
        }
    }
}
</style>